<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Inventory">Inventory</span>
      </div>

      <!-- Center -->
      <div class="app-toolbar-center">
    <ng-container *ngIf="organizations && organizations.length > 1">
      <div style="min-width: 100px;">
        <mat-select placeholder="Organization" i18n-placeholder="@@Organization" (selectionChange)="selectedOrganization=$event.value" required [ngModel]="selectedOrganization" style="display: inline">
          <mat-option value="0" i18n="@@All Organizations">All Organizations</mat-option>
          <ng-container *ngFor="let organization of organizations">
            <mat-option [value]="organization">{{organization}}</mat-option>
          </ng-container>
        </mat-select>
      </div>
    </ng-container>
    <button (click)="displayToggle = !displayToggle; refresh()" mat-icon-button color="primary"><mat-icon *ngIf="!displayToggle" i18n-title="@@Show Blocks" title="Show Blocks" color="accent">format_list_bulleted</mat-icon><mat-icon *ngIf="displayToggle" i18n-title="@@Show Table" title="Show Table" style="color: blue">format_list_bulleted</mat-icon></button>
      <button mat-fab color="primary" (click)="openAddDialog()" i18n-matTooltip="@@Add Inventory Product" matTooltip="Add Inventory Product"><i class="material-icons">add</i></button>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="facilityinventory"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <ng-container *ngIf="displayToggle">
        <div class="app-content" style="display: flex; flex-wrap: wrap;">
          <ng-container *ngFor="let facililtyInventoryProduct of facilityInventoryProducts">
            <app-facility-inventory-product *ngIf="selectedOrganization === '0' || facililtyInventoryProduct.product.org_ID === selectedOrganization" [facilityInventoryProduct]="facililtyInventoryProduct" style="max-width: 800px" [showCharts]="showCharts" [edit]="edit" [products]="products"></app-facility-inventory-product>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="!displayToggle">
        <div class="app-content app-table-content">
          <app-table *ngIf="columns && eventHandler && renderedData" [columns]="columns" [eventHandler]="eventHandler" [data]="renderedData" [expandedTableRowTemplate]="expandedTableRowTemplate" [dataServiceStatus]="'LOADED'" [showFilters]="true">
            <ng-template #expandedTableRowTemplate let-element>
              <app-facility-inventory-product *ngIf="selectedOrganization === '0' || element.product.org_ID === selectedOrganization" [facilityInventoryProduct]="element" style="max-width: 800px" [showCharts]="showCharts" [edit]="edit" [products]="products"></app-facility-inventory-product>
            </ng-template>
          </app-table>
        </div>
      </ng-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>






